import Back from "../common/Back";
import Recent from "../home/recent/Recent";
import img from "../images/Real-estate.png";
import { Helmet } from "react-helmet-async";
import FilterSection from "./FilterSection.jsx";
import React, { useState } from "react";

export function RecentBage({ language }) {
  const [filters, setFilters] = useState({
    propertyType: "",
    priceRange: [0, Number.MAX_SAFE_INTEGER],
    bedrooms: "0",
    bathrooms: "0",
    availability: "",
    searchQuery: "",
    sortBy: "",
  });

  // دالة لتطبيق الفلاتر
  const handleApplyFilters = (appliedFilters) => {
    console.log("Applied Filters:", appliedFilters);
    // يمكنك هنا إجراء أي عمليات أخرى بناءً على الفلاتر المطبقة
  };
  return (
    <>
      <Helmet>
        <title>علم الريادة | جميع العقارات </title>
      </Helmet>
      <section className="pricing mb">
        <Back
          name={language !== "arabic" ? "All Real Estates" : "جميع العقارات"}
          title={
            language !== "arabic"
              ? "Get your property now and create your future!"
              : "احصل على عقارك الآن واصنع مستقبلك!"
          }
          cover={img}
        />
        {/* <FilterSection
          filters={filters}
          setFilters={setFilters}
          onApplyFilters={handleApplyFilters}
        /> */}
        <Recent language={language} isHome={false} isDash={false} />
      </section>
    </>
  );
}
